var React = require('react');

function Users (props) {
    return React.createElement("svg",props,[React.createElement("rect",{"width":"48","height":"48","rx":"6","fill":"#F9C33D","key":0}),React.createElement("path",{"d":"M24 16.3542C24.7329 15.5238 25.8053 15 27 15C29.2091 15 31 16.7909 31 19C31 21.2091 29.2091 23 27 23C25.8053 23 24.7329 22.4762 24 21.6458M27 33H15V32C15 28.6863 17.6863 26 21 26C24.3137 26 27 28.6863 27 32V33ZM27 33H33V32C33 28.6863 30.3137 26 27 26C25.9071 26 24.8825 26.2922 24 26.8027M25 19C25 21.2091 23.2091 23 21 23C18.7909 23 17 21.2091 17 19C17 16.7909 18.7909 15 21 15C23.2091 15 25 16.7909 25 19Z","stroke":"white","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Users.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Users;

Users.default = Users;
